import {
    ChatMessagesParams,
    CreateChatMessageParams,
    FilesGalleryParams,
    TopicsFilesGalleryParams,
} from 'types/getParams';
 
import { CRMAPIBase } from '@api/crmApiBase';
import { ChatMessageResp } from '@api/responseModels/chatMessages/chatMessageResponse';
import { ChatMessagesResp } from '@api/responseModels/chatMessages/chatMessagesResponse';
import { FilesGalleryResp } from '@api/responseModels/chatMessages/filesGalleryResponse';
import { RecipientsFilesGalleryResp } from '@api/responseModels/chatMessages/recipientsFilesGalleryResponse';
import { TopicsFilesGalleryResp } from '@api/responseModels/chatMessages/topicsFilesGalleryResponse';
import { RequestResult } from '@api/responseModels/requestResult';

class ChatMessagesGroup extends CRMAPIBase {
    async getChatMessages(params: ChatMessagesParams): Promise<RequestResult<ChatMessagesResp>> {
        const response = await this.get<ChatMessagesResp>('/chat-messages', params);
        return response;
    }

    async createChatMessage(
        params: CreateChatMessageParams
    ): Promise<RequestResult<ChatMessageResp>> {
        const response = await this.post<ChatMessageResp>(`/chat-messages`, params);
        return response;
    }

    async updateChatMessage(
        crm_id,
        worker_position_id,
        chat_id,
        message
    ): Promise<RequestResult<ChatMessageResp>> {
        const response = await this.put<ChatMessageResp>(`/chat-messages/${chat_id}`, {
            crm_id,
            worker_position_id,
            message,
        });
        return response;
    }

    async deleteChatMessage(
        crm_id,
        worker_position_id,
        messageId
    ): Promise<RequestResult<ChatMessageResp>> {
        const response = await this.delete<ChatMessageResp>(`/chat-messages/${messageId}`, {
            crm_id,
            worker_position_id,
        });
        return response;
    }

    async getRecipientsFilesGallery(
        crm_id,
        chat_id
    ): Promise<RequestResult<RecipientsFilesGalleryResp>> {
        const response = await this.get<RecipientsFilesGalleryResp>(
            '/chat-messages/recipientsFilesGallery',
            {
                crm_id,
                chat_id,
            }
        );
        return response;
    }

    async getTopicsFilesGallery(
        params: TopicsFilesGalleryParams
    ): Promise<RequestResult<TopicsFilesGalleryResp>> {
        const response = await this.get<TopicsFilesGalleryResp>(
            '/chat-messages/topicsFilesGallery',
            params
        );
        return response;
    }

    async getFilesGallery(params: FilesGalleryParams): Promise<RequestResult<FilesGalleryResp>> {
        const response = await this.get<FilesGalleryResp>('/chat-messages/files', params); 
        return response;
    }
}

export { ChatMessagesGroup };
